
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenShot as ObiScreenShotElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-shot.js';
 
 
 

 
 export const ObiScreenShot = createComponent({
   react: React,
   tagName: 'obi-screen-shot',
   elementClass: ObiScreenShotElement,
   events: {
     
   }
  });
 
 